import { useEffect, useState } from 'react';

import { translations } from './../../../../i18/translations.js';
import RadioButtonGroup from './../../../../util/RadioButtonGroup.js';

const FirstLetterSelect = ({ onlyMember, firstLetter, handleSelectionChange }) => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const [firstLetters, setFirstLetters] = useState([]);

    const fetchFirstLetters = async () => {
        const payload = {
            filter: {onlyMember}
        };
        try {
            const response = await fetch(`${API_URL}/admin/get_administration_user_first_letter_list.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            const buttons = data.map(letter => ({
                    title: letter,
                    value: letter
                }));

            setFirstLetters(buttons);
        } catch (error) {
            console.error('Error fetching letters:', error);
        }
    };

    useEffect(() => {
        fetchFirstLetters();
    }, [onlyMember]);

    return (
            <RadioButtonGroup buttons={firstLetters} onSelectionHandler={handleSelectionChange} initialValue={firstLetter} emptyValue="" />
            );
};

export default FirstLetterSelect;
